export const storeProducts = [
  {
    id: 1,
    category: "Books & Devotionals",
    name: "Healing from the Inside Out",
    description: "A faith-based guide to hormonal health and spiritual wellness, written by Dr. Sheldon Mckenzie.",
    price: 24.99,
    image: "https://public.readdy.ai/ai/img_res/43c01681c8be7bddc539e38230a02b55.jpg",
    badge: "Bestseller",
  },
  {
    id: 2,
    category: "Books & Devotionals",
    name: "Faith & the Endocrine System",
    description: "Exploring the connection between spiritual peace and hormonal balance through scripture and science.",
    price: 19.99,
    image: "https://readdy.ai/api/search-image?query=Medical%20and%20faith%20themed%20book%20cover%20with%20stethoscope%20and%20open%20Bible%2C%20clean%20white%20background%2C%20professional%20product%20photography%2C%20warm%20tones&width=400&height=400&seq=book2&orientation=squarish",
    badge: null,
  },
  {
    id: 3,
    category: "Audio & Sermons",
    name: "30-Day Healing Devotional (Audio)",
    description: "A month of daily audio devotionals combining scripture with health affirmations.",
    price: 14.99,
    image: "https://readdy.ai/api/search-image?query=Audio%20CD%20or%20digital%20download%20product%20with%20cross%20and%20sound%20waves%20design%2C%20clean%20minimal%20packaging%2C%20soft%20cream%20background%2C%20professional%20product%20photography&width=400&height=400&seq=audio1&orientation=squarish",
    badge: "New",
  },
  {
    id: 4,
    category: "Audio & Sermons",
    name: "Sermon Series: Body as Temple",
    description: "6-part sermon series on honoring God through physical and spiritual health.",
    price: 9.99,
    image: "https://readdy.ai/api/search-image?query=Sermon%20audio%20series%20product%20packaging%20with%20church%20and%20light%20rays%20design%2C%20warm%20gold%20tones%2C%20clean%20background%2C%20professional%20product%20photography&width=400&height=400&seq=audio2&orientation=squarish",
    badge: null,
  },
  {
    id: 5,
    category: "Health Supplements",
    name: "Thyroid Support Complex",
    description: "Physician-formulated supplement blend to support healthy thyroid function.",
    price: 39.99,
    image: "https://readdy.ai/api/search-image?query=Premium%20health%20supplement%20bottle%20with%20clean%20white%20label%2C%20green%20and%20gold%20accents%2C%20professional%20product%20photography%20on%20white%20background%2C%20minimalist%20design&width=400&height=400&seq=supp1&orientation=squarish",
    badge: "Top Rated",
  },
  {
    id: 6,
    category: "Health Supplements",
    name: "Blood Sugar Balance Formula",
    description: "Natural supplement to support healthy glucose metabolism, doctor-approved.",
    price: 44.99,
    image: "https://readdy.ai/api/search-image?query=Health%20supplement%20bottle%20with%20blue%20and%20white%20label%2C%20glucose%20balance%20formula%2C%20clean%20minimal%20design%2C%20professional%20product%20photography%20on%20light%20background&width=400&height=400&seq=supp2&orientation=squarish",
    badge: null,
  },
  {
    id: 7,
    category: "Apparel",
    name: "Faith Over Fear Tee",
    description: "Premium cotton t-shirt with inspirational scripture print. Available in multiple colors.",
    price: 29.99,
    image: "https://readdy.ai/api/search-image?query=White%20premium%20cotton%20t-shirt%20with%20elegant%20scripture%20text%20print%2C%20flat%20lay%20product%20photography%20on%20clean%20cream%20background%2C%20minimalist%20style&width=400&height=400&seq=apparel1&orientation=squarish",
    badge: null,
  },
  {
    id: 8,
    category: "Digital Downloads",
    name: "Hormone Health Masterclass",
    description: "Comprehensive digital course covering hormonal health, nutrition, and faith-based wellness.",
    price: 79.99,
    image: "https://readdy.ai/api/search-image?query=Digital%20course%20product%20mockup%20on%20laptop%20screen%2C%20health%20and%20wellness%20theme%2C%20clean%20modern%20design%2C%20professional%20photography%20on%20white%20background&width=400&height=400&seq=digital1&orientation=squarish",
    badge: "Popular",
  },
];

export const storeCategories = [
  "All",
  "Books & Devotionals",
  "Audio & Sermons",
  "Health Supplements",
  "Apparel",
  "Digital Downloads",
];
